
import { Button, CardMedia, Tooltip } from '@mui/material';
import React from 'react';
import { useSlider } from '../../helper/functions/hooks';
import Break from '../Break';
import { alt, images, IMG_SIZE } from './helper';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { NeutralColor } from '../../helper/constants/colors';
import RenderIf from '../RenderIf';
import {Center} from "../../components/Align"
import { useWindowSize, isHorizontal } from '../../helper/functions/hooks/windowsize';
import { optionalString } from '../../helper/functions';
const WidescreenImage = ({ src, alt="poop", size }: any): JSX.Element =>
(
    <Center>
            <Tooltip title={alt}>
                <img src={src} width={size} height={size} alt={alt}/>
            </Tooltip>
    </Center>
)
const RandomImage = (): JSX.Element => {
    const { width, height } = useWindowSize()
    const [count, { increment, decrement }] = useSlider(images.length -1)
    return (
        <>
            <RenderIf
                condition={isHorizontal(width, height)}
                fallback= //user is viewing verticaly
                {
                    <CardMedia component={"img"}
                        image={images[count]}
                        height={IMG_SIZE}
                        width={IMG_SIZE}
                        alt={optionalString(alt[count])}/>
                }>
                {/* user is viewing horizontally */}
                <WidescreenImage
                    src={images[count]}
                    alt={alt[count]}
                    size={IMG_SIZE} />
            </RenderIf>
            <Break num={0} />
            <Center >
                <Button onClick={decrement}><KeyboardArrowLeftIcon htmlColor={NeutralColor.light} fontSize='medium' /></Button>
                <Button onClick={increment}><KeyboardArrowRightIcon htmlColor={NeutralColor.light} fontSize='medium' /></Button>
            </Center>
        </>
    )
}
export default RandomImage;
